"use client";

import type React from "react";

interface ContextProviderProps {
  children: React.ReactNode;
}

export default function ContextProvider({ children }: ContextProviderProps) {
  return <>{children}</>;
}
